module.exports = __webpack_public_path__ + "static/media/referral-fr.8e7b7d1d.png";